// extracted by mini-css-extract-plugin
export default {"bottom_floating":"BottomFloating_bottom_floating__wNieF"};